import { Component, type ReactNode } from 'react';

// Last-resort backstop: a render-time throw (e.g. unexpected API shape)
// otherwise white-screens the app with no styled feedback at all.
export class ErrorBoundary extends Component<
  { children: ReactNode },
  { error: Error | null }
> {
  state = { error: null as Error | null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error) {
    console.error(error);
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="flex h-screen items-center justify-center p-6">
        <div className="card-editorial max-w-md space-y-4 p-6">
          <p className="kicker">Stop press</p>
          <h1 className="display-sm text-2xl">Something broke</h1>
          <p className="text-sm text-ink-soft">{String(this.state.error)}</p>
          <button
            type="button"
            onClick={() => window.location.reload()}
            className="rounded-xs bg-ink px-4 py-2 text-sm font-medium text-paper transition hover:bg-accent"
          >
            Reload
          </button>
        </div>
      </div>
    );
  }
}
